import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { t } from 'ttag';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { useApolloClient } from '@apollo/react-hooks';
import { MyClubCApi } from '../../../api';
import LinearProgress from '@material-ui/core/LinearProgress';

export const AddGroupModalController = ({ athleteId, onAccept, onClose }) => {
  const client = useApolloClient();
  const newApi = new MyClubCApi(client);
  const [loading, setLoading] = React.useState(false);
  const [group, setGroup] = React.useState(null);
  const [groups, setGroups] = React.useState([]);
  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const res = await newApi.getGroups({});
      setGroups(res);
      setLoading(false);
    }
    fetchData();
  }, []);

  const handleOnAccept = async () => {
    setLoading(true);
    const res = await newApi.activateAthlete(athleteId);
    if (res.ok) {
      const groupRes = await newApi.addAthleteToGroup({
        athleteId: athleteId,
        groupId: group.id,
      });
      onAccept(groupRes);
    } else {
      onAccept(res);
    }
    setLoading(false);
  };

  const handleOnClose = () => {
    onClose();
  };

  const handleOnChange = (e, v) => {
    setGroup(v);
  };

  return (
    <AddGroupModal
      value={group}
      groups={groups}
      onChange={handleOnChange}
      onAccept={handleOnAccept}
      onClose={handleOnClose}
      loading={loading}
      acceptDisabled={!group}
    />
  );
};

export const AddGroupModal = ({
  value,
  groups,
  onChange,
  onAccept,
  onClose,
  loading,
  acceptDisabled,
}) => (
  <Dialog fullWidth open={true} onClose={onClose}>
    {loading ? <LinearProgress /> : null}
    <DialogTitle>{t`Додати до групи`}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        <Autocomplete
          loading={loading}
          size='large'
          requried
          options={groups}
          getOptionLabel={(o) =>
            o
              ? `${o.name} (${o.gym.name}/${o.sectionObj.name}/${o.trainer.fullInitials})`
              : ''
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={t`Виберіть групу`}
              variant='outlined'
            />
          )}
          value={groups.find((item) => item && item.id === value)}
          onChange={onChange}
        />
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        style={{ margin: '20px 0 20px 0' }}
        margin='normal'
        type='button'
        variant='contained'
        color='primary'
        onClick={onAccept}
        disabled={loading || acceptDisabled}
      >
        {t`Застосувати`}
      </Button>
      <Button onClick={onClose} color='primary' disabled={loading}>
        {t`Відмінити`}
      </Button>
    </DialogActions>
  </Dialog>
);
